import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09882b8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = {
  key: 0,
  class: "pc-header-padding"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "关于", -1))
const _hoisted_4 = { class: "about" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about-img" }, null, -1))
const _hoisted_6 = { class: "about-ver" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "版本号 ", -1))
const _hoisted_8 = { class: "about-docs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoreInfoItem = _resolveComponent("MoreInfoItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["more-info", { 'sl-full': _ctx.isFullScreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.envStore.isInPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        title: "返回",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_ctx.deviceInfoWatchData.client_version), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_MoreInfoItem, {
          title: "用户协议",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goProtocol('迅雷产品服务使用协议')))
        }),
        _createVNode(_component_MoreInfoItem, {
          title: "隐私协议",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goProtocol('迅雷隐私权政策')))
        }),
        _createVNode(_component_MoreInfoItem, {
          title: "云盘协议",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goProtocol('迅雷云盘服务协议')))
        }),
        _createVNode(_component_MoreInfoItem, {
          title: "会员协议",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goProtocol('迅雷会员服务协议')))
        })
      ])
    ])
  ], 2))
}